import { useEffect } from 'react';
import { trackEvent } from '../../analytics/sml/analytics';

export type NoResultSurface = 'commandPalette' | 'browse' | 'other';
export type NoResultKind = 'artist' | 'track' | 'playlist' | 'all' | 'other';

/** The wait after the last key: a word in progress is not an empty search. */
export const NO_RESULT_WAIT_MS = 800;

/** `search_no_result` for a search that stayed empty. The text of the search goes in no event. */
export function useTrackNoResult(surface: NoResultSurface, kind: NoResultKind, query: string): void {
  useEffect(() => {
    const timer = setTimeout(() => trackEvent('search_no_result', { surface, kind }), NO_RESULT_WAIT_MS);
    return () => clearTimeout(timer);
  }, [kind, query, surface]);
}
